

































































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import PersonalDetailModel from "../../js/dataModels/panels/personalDetailModel";
import PetDetailModel from "../../js/dataModels/panels/petDetailModel";
import SpiecesModel from "../../js/dataModels/Species/speciesModel";
import BreedModel from "../../js/dataModels/Breeds/breedModel";
import { Gender } from "../../js/enums/gender";
import PetOwnerInquiryModel from "../../js/dataModels/PetOwnerInquiry/petOwnerInquiryModel";
import InquiryResponseModel from "../../js/dataModels/PetOwnerInquiry/inquiryResponseModel";
import { SeeingVetAnswer } from '../../js/enums/seeingVetAnswer';
import { species } from '../../js/enums/species';

const NotKnown = "Not Known";

@Component({
    name: 'petDetails',
    components: { }
})

export default class PetDetails extends Vue {
    @Prop({ type: Boolean }) visible!: boolean;
    @Prop({ type: String }) serviceId!: string;
    @Prop({ type: Number }) servicePathId!: number;
    @Prop({ type: Boolean }) startChatVisible!: boolean;
    @Prop({ type: Boolean }) requestCallbackVisible!: boolean;
    @Prop({ type: Object }) headers!: any;

    medicationNotesVisible: boolean = false;
    petDetails: PetDetailModel;
    personalDetails: PersonalDetailModel;
    petAgeList: any[];
    seeingVetAnswers: any[];
    titleList: string[] = [];
    species: SpiecesModel[];
    breeds: BreedModel[];
    availableBreeds: BreedModel[];
    genderMale: Gender = Gender.Male;
    genderFemale: Gender = Gender.Female;
    responseError: string = "";
    requestCallbackSent: boolean = false;
    sendingRequest: boolean = false;
    seeingAVetWarning: boolean = false;
    secondOpinionQuestion: string = "";

    constructor() {
        super();
        this.petAgeList = [];
        this.species = [];
        this.breeds = [];
        this.availableBreeds = [];
        this.seeingVetAnswers = [];
        this.petDetails = new PetDetailModel();
        this.personalDetails = new PersonalDetailModel();
        this.petDetails.medicationNotes = NotKnown;
    }

    get getError(): string {
        if (this.errors.any() || !this.isSecondOpinionOk) {
            return "Required information is missing or not valid. Please check your entries above.";
        }

        return this.responseError;
    }

    get isSecondOpinionOk(): boolean {
        return !this.seeingAVetWarning || this.petDetails.secondOpinion;
    }

    @Watch("visible")
    visibleChanged() {
        this.responseError = "";
        if (this.visible) {
            this.$http.get(`${this.$rootApiPath}PetOwnerInquiry/petDetailsInitialData/${this.serviceId}`, { headers: this.headers }).then((e) => {
                this.titleList = e.body.personTitles;
                this.petAgeList = e.body.petAges;
                this.seeingVetAnswers = e.body.seeingVetAnswers;
                this.species = e.body.species.filter(s => {
                    return s.id != species.MultipleAnimals;
                });
                this.breeds = e.body.breeds;
                this.secondOpinionQuestion = e.body.secondOpinionQuestion;
            }, this.dataReadFailure);
        }
    }

    dataReadFailure(event: any): void {
        this.$emit("dataReadFailure", event);
    }

    onSelectedSpeciesChange(): void {
        if (!this.petDetails.speciesId) {
            this.petDetails.breedId = null;
            this.availableBreeds = [];
            return;
        }
        if (this.petDetails.breedId) {
            var selectedBreed = this.breeds.find(b => b.id === this.petDetails.breedId);
            if (selectedBreed && (selectedBreed.speciesId !== this.petDetails.speciesId)) {
                this.petDetails.breedId = null;
            }
        }
        this.availableBreeds = this.breeds.filter(b => b.speciesId === this.petDetails.speciesId);
    }

    resetMedicationNotesOnClick() {
        if (this.petDetails.isOnMedication == true) {
            this.petDetails.medicationNotes = "";
            this.medicationNotesVisible = true;
        } else {
            this.petDetails.medicationNotes = NotKnown;
            this.medicationNotesVisible = false;
        }
    }

    sendRequest(validationResult: any, apiUrl: string, successCallback: (inquiryResponse: any) => void): void {
        if (!validationResult || !this.isSecondOpinionOk) {
            this.sendingRequest = false;
            return;
        }
        const parsedServiceId = parseInt(this.serviceId, 10);
        if (isNaN(parsedServiceId)) {
            this.responseError = "Invalid Service Id";
            this.sendingRequest = false;
            return;
        }
        const petOwnerInquiry = new PetOwnerInquiryModel();
        petOwnerInquiry.personalDetails = this.personalDetails;
        petOwnerInquiry.petDetails = this.petDetails;
        petOwnerInquiry.serviceId = parsedServiceId;
        petOwnerInquiry.servicePathId = this.servicePathId;
        this.responseError = "";
        this.$http.post(apiUrl, petOwnerInquiry, { headers: this.headers }).then((result: any): void => {
            if (result) {
                this.sendingRequest = false;
                successCallback(result.data);
            } else {
                this.dataReadFailure(null);
                this.sendingRequest = false;
            }
        }, (event: any) => {
            this.dataReadFailure(event);
            this.sendingRequest = false;
        });
    }

    startChat(): void {
        if (this.sendingRequest) {
            return;
        }
        this.sendingRequest = true;
        this.$validator.validateAll().then((result: any) => this.sendRequest(result, Vue.prototype.$rootApiPath + "PetOwnerInquiry/startchat", this.successfulChatRequest));
    }

    successfulChatRequest(response: InquiryResponseModel): void {
        if (!response) {
            return;
        }
        if (response.chatUrl) {
            window.location.href = response.chatUrl;
        } else {
            this.responseError = response.error;
        }
    }

    requestCallback(): void {
        if (this.sendingRequest) {
            return;
        }
        this.sendingRequest = true;
        this.$validator.validateAll().then((result: any) => this.sendRequest(result, Vue.prototype.$rootApiPath + "PetOwnerInquiry/requestcallback", this.successfulCallbackRequest));
    }

    successfulCallbackRequest(response: string): void {
        if (response) {
            this.responseError = response;
        } else {
            this.requestCallbackSent = true;
            this.$emit("hideEditor");
        }
    }

    onSeeingVetChange(): void {
        const isSeeingAVet: boolean = this.petDetails && this.petDetails.isSeeingAVet === SeeingVetAnswer.Yes;
        this.petDetails.secondOpinion = isSeeingAVet;
        this.seeingAVetWarning = isSeeingAVet;
    }
}
